import styled from '@xstyled/styled-components';
import React from 'react';
import { Item, registry, RenderProps } from '../Item';
import { BULLET_LIST } from '../itemIds';
import { useEditorStore } from '~/shell/Store';
import LightButton from '~/editor/buttons/LightButton';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {}

const Ul = styled.ul`
  width: 100% !important;
  > li {
    margin-bottom: 15px;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 150%;
  }
`;

export class BulletList extends Item<typeof BULLET_LIST> {
  protected render({ children }: RenderProps<Props>) {
    const { contentEditable, sequence, addSubItem } = useEditorStore();

    const AddNewItem = () => {
      if (!sequence) {
        return;
      }

      const list = sequence.items.find(
        (item: { id: string; type: string }) => item.type === 'LIST'
      );

      if (list && list.items && list.items.length > 0) {
        const lastItem = list.items[list.items.length - 1];

        if (lastItem) {
          const newItem = {
            ...lastItem,
            id: `${Date.now()}`,
            position: lastItem.position! + 1,
            appear: lastItem.appear
          };

          newItem.title = 'Type Here';

          addSubItem({
            sequenceId: sequence.id,
            data: {
              type: 'Text',
              appear: newItem.appear,
              title: newItem.title,
              position: newItem.position + 1,
              parent_id: list.id
            },
            newItem: newItem
          });
        }
      }
    };

    return (
      <Ul aria-live="polite">
        {children}
        {contentEditable && (
          <LightButton onClick={AddNewItem}>Add Item</LightButton>
        )}
      </Ul>
    );
  }
}

registry[BULLET_LIST] = BulletList;
